function Wrapper({ children, className }) {
    return <div className="w-full  flex flex-col py-2">{children}</div>;
}

export default Wrapper;
